export default __webpack_public_path__ + "static/media/uploaded-file.a93bd055.svg";